import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Link } from "react-router-dom";

import "../../common/planTheme.css";
import "./WeeklyPlan.css";
import DayPlan from "./DayPlan";
import axios from "axios";
import Swal from "sweetalert2";
import {DecryptED} from "../../DecryptJS/Decrypt"
import { getWeeklyPlanConfig } from "../weeklyPlanConfig";

const WeeklyPlan = () => {
  let { sid, userid } = useParams();
  sid = DecryptED(sid);
  userid = DecryptED(userid);
  const cfg = getWeeklyPlanConfig(sid);
  const [weeklyData, setWeeklyData] = useState([]);
  const [lessonName, setLessonName] = useState("");
  const [currentAcadId, setCurrentAcadId] = useState("");
  const [classList, setClassList] = useState([]);
  const [subjectList, setSubjectList] = useState([]);
  const [month, setMonth] = useState("");
  const [classId, setClassId] = useState("");
  const [subjectId, setSubjectId] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [loading, setLoading] = useState(true);

  const days = [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!classId || !month || !subjectId || !lessonName) {
      const missing = [];
      if (!classId) missing.push("Class");
      if (!month) missing.push("Date");
      if (!subjectId) missing.push("Subject");
      if (!lessonName) missing.push("Lesson Name");
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: `Please fill the required fields: ${missing.join(", ")}`,
      });
      return;
    }
    if (!weeklyData.length) {
      Swal.fire(
        "Please add at least one day",
        "Open a weekday, fill it in and click Save before submitting.",
        "warning"
      );
      return;
    }
    const data = {
      sid,
      staff_id: userid,
      acad_id: currentAcadId,
      class_id: classId,
      subject_id: subjectId,
      month: month,
      lession_name: lessonName,
      days: weeklyData,
    };
    setSubmitting(true);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/api/admin/weeklyPlan/add`,
        data,
        {
          headers: {
            Authorization: "#$laksdfnlknoea#$@$%^&%$",
          },
        }
      );
      if (response.data && response.data.result === "1") {
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Your work has been saved",
          showConfirmButton: false,
          timer: 1500,
        });
      } else {
        Swal.fire(
          "Could not save",
          (response.data && response.data.error) ||
            "Something went wrong. Please try again.",
          "error"
        );
      }
    } catch (error) {
      console.error(error);
      Swal.fire("Error", "Could not save the weekly plan. Please try again.", "error");
    } finally {
      setSubmitting(false);
    }
  };
  const selectClassIdHandler = async (e) => {
    const newClassId = e.target.value;
    setClassId(newClassId === "default" ? "" : newClassId);
    setSubjectId("");
    setSubjectList([]);
    if (newClassId === "default") return;
    try {
      const response = await axios.post(
        "https://topschool.prisms.in/rest/index.php/staff_list.json",
        {
          fun_name: "getAccessClassSubject",
          sid,
          staff_id: userid,
          div_id: newClassId,
        }
      );
      setSubjectList((response.data && response.data.result) || []);
    } catch (error) {
      console.error(error);
      Swal.fire("Error", "Could not load subjects for this class.", "error");
    }
  };
  useEffect(() => {
    const getAccessableClass = async () => {
      const data = {
        fun_name: "getAccessClass",
        sid: sid,
        staff_id: userid,
      };
      try {
        const response = await axios.post(
          "https://topschool.prisms.in/rest/index.php/staff_list.json",
          data
        );
        setClassList((response.data && response.data.result) || []);
      } catch (error) {
        console.error(error);
        Swal.fire("Error", "Could not load classes.", "error");
      } finally {
        setLoading(false);
      }
    };
    getAccessableClass();

    const getCurrentAcadId = async () => {
      const data = {
        fun_name: "currentAcadId",
        sid: sid,
      };
      try {
        const response = await axios.post(
          "https://topschool.prisms.in/rest/index.php/staff_list.json",
          data
        );
        setCurrentAcadId((response.data && response.data.result && response.data.result[0] && response.data.result[0].acadid) || "");
      } catch (error) {
        console.error(error);
      }
    };
    getCurrentAcadId();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (loading) {
    return (
      <div className="lp-scope weeklyform-page">
        <p className="lp-page-title" style={{ textAlign: "center" }}>Weekly Lesson Plan</p>
        <p style={{ textAlign: "center", padding: "20px", color: "#1565c0" }}>
          Loading…
        </p>
      </div>
    );
  }

  return (
    <div className="lp-scope weeklyform-page">
      <div className="weeklyform-headRow">
        <Link className="weeklyform-navLink" to={`/weeklyHome/${sid}/${userid}`}>
          Home
        </Link>
        <p className="lp-page-title" style={{ margin: 0 }}>Weekly Lesson Plan</p>
        <Link className="weeklyform-navLink" to={`/weeklyReport/${sid}/${userid}`}>
          Report
        </Link>
      </div>
      <form className="form lp-card" onSubmit={handleSubmit}>
        <div className="user-details">
          <p className="lp-section-title">Lesson Details</p>
          <div className="form-details">
            <div className="form-inputs">
              <label className="lp-field-label" htmlFor="classSelect">
                Class<span className="lp-required">*</span>
              </label>
              <select
                className="lp-select"
                id="classSelect"
                value={classId || "default"}
                onChange={selectClassIdHandler}
              >
                <option value="default">Select Class</option>
                {classList &&
                  classList.map((data, idx) => {
                    return (
                      <option key={idx} value={data.id}>
                        {data.div_name}
                      </option>
                    );
                  })}
              </select>
            </div>
            <div className="form-inputs">
              <label className="lp-field-label" htmlFor="month">
                Date<span className="lp-required">*</span>
              </label>
              <input
                className="lp-input"
                onChange={(e) => setMonth(e.target.value)}
                name="month"
                id="month"
                type="date"
                value={month}
              />
            </div>
          </div>
          <div className="form-details">
            <div className="form-inputs">
              <label className="lp-field-label" htmlFor="subjectSelect">
                Subject<span className="lp-required">*</span>
              </label>
              <select
                className="lp-select"
                id="subjectSelect"
                value={subjectId || "default"}
                onChange={(e) => setSubjectId(e.target.value === "default" ? "" : e.target.value)}
                disabled={!classId}
              >
                <option value="default">Select Subject</option>
                {subjectList &&
                  subjectList.map((data, idx) => {
                    return (
                      <option key={idx} value={data.id}>
                        {data.subject}
                      </option>
                    );
                  })}
              </select>
            </div>
            <div className="form-inputs">
              <label className="lp-field-label" htmlFor="lessonName">
                Lesson Name<span className="lp-required">*</span>
              </label>
              <input
                className="lp-input"
                value={lessonName}
                onChange={(e) => setLessonName(e.target.value)}
                id="lessonName"
                type="text"
              />
            </div>
          </div>
        </div>
        <p className="lp-section-title" style={{ marginTop: "24px" }}>Day-by-Day Plan</p>
        <div className="Accordion">
          {days.map((day, idx) => {
            return (
              <DayPlan
                day={day}
                key={idx}
                weeklyData={weeklyData}
                setWeeklyData={setWeeklyData}
                cfg={cfg}
              />
            );
          })}
        </div>
        <div className="btn-div">
          <button
            type="submit"
            className="lp-btn lp-btn-primary"
            disabled={submitting}
          >
            {submitting ? "Submitting…" : "Submit"}
          </button>
        </div>
      </form>
    </div>
  );
};

export default WeeklyPlan;
